module.exports = __webpack_public_path__ + "bdcbc460eb6218eb54741fc66f5687f3.pdf";